<template>
  <div class="public-start-view">
    <title-component :size="1" :lineSeparator="'under'">
      <translate>Welcome to IDUN audit portal for Kiwa Certification</translate>
    </title-component>
    <div class="columns section-bordered">
      <!-- Left panel -->
      <div class="column">
        <title-component :size="4">
          <translate>Apply for certification</translate>
        </title-component>
        <p v-translate>
          If you are not a Kiwa customer and would like to apply for a certification click here on the link below.
          The certification we currently support are:
        </p>
        <ul>
          <li v-for="(service, key) in getAppliableServices" :key="key">
            {{ service.name }} {{ service.shortName }}
          </li>
        </ul>
        <div class="btns-container">
          <router-link class="button is-uppercase is-success" :to="{ name: 'ApplicationListView'}" v-translate>
            Go to appliation
          </router-link>
        </div>
      </div>
      <!-- Right panel -->
      <div class="column">
        <title-component :size="4">
          <translate>Current customers regarding certification</translate>
        </title-component>
        <p class="mt-10"><strong>
          <translate>
            If you are a customer of Kiwa Certification AB today and have received a notification about renewal or annual reporting, you should log in to your Idun case page and make the additions that are on your overview.
            </translate>
          </strong>
        </p>
        <p class="mt-10"><strong>
          <translate>
            You can find forms at https://kiwa.se under the respective certification.
            </translate>
          </strong>
        </p>
        <p class="mt-10"><strong>
          <translate>
            If you have been certified or you have a valid certificate with Kiwa Certification AB and want to apply for a different certification or authorization level, you must log in to your case page and click on New application on your overview.
            </translate>
          </strong>
        </p>
        <p class="mt-10">
          <translate>
            If you have changed your email address, you must contact Kiwa Certification AB, 0455-305600 ext. or se.bygg@kiwa.com.
          </translate>
        </p>
        <div class="columns is-mobile btns-container">
          <div class="column">
            <router-link class="button is-uppercase is-success" :to="{ name: 'LoginView'}" v-translate>
              Login
            </router-link>
          </div>
          <div class="column has-text-right">
            <router-link class="button is-uppercase is-success is-outlined" :to="{ name: 'ResetPasswordView'}" v-translate>
              Create password
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- Browser compatiblity check -->
    <browser-compatibility-component />
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import TitleComponent from '@/components/layout/TitleComponent'
  import { setContainedHeightMixin, errorHandler } from '@/mixins/mixins'
  import BrowserCompatibilityComponent from '@/components/layout/BrowserCompatibilityComponent'

  export default {
    name: 'welcome-view',
    mixins: [setContainedHeightMixin, errorHandler],
    components: {
      TitleComponent,
      BrowserCompatibilityComponent
    },
    computed: {
      ...mapState({
        services: state => state.serviceModule.services
      }),
      ...mapGetters([
        'getAppliableServices'
      ])
    },
    methods: {
      ...mapActions([
        'getServices'
      ])
    },
    created () {
      this.getServices().catch((err) => {
        this.handleError(err)
      })
    }
  }
</script>

<style lang="sass" scoped>
  .section-bordered
    > div
      @media screen and (min-width: 769px)
        &:nth-child(1)
          margin-right: 1rem
        &:nth-child(2)
          margin-left: 1rem
</style>
